var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWildsFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.117 3.186c5.22.87 10.547.87 15.766 0A.96.96 0 0121 4.132V13a9 9 0 01-18 0V4.132a.96.96 0 011.117-.946zM9.41 15a.41.41 0 00-.409.41C9 16.84 10.16 18 11.59 18h.82c1.43 0 2.59-1.16 2.59-2.59a.41.41 0 00-.41-.41H9.41zM9 7.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm6 0a1.5 1.5 0 100 3 1.5 1.5 0 000-3z",
    fill: "currentColor"
  })));
}
SvgWildsFilled.displayName = 'WildsFilled';
export default SvgWildsFilled;